module.exports = __webpack_public_path__ + "img/invoicing_configuration.d0bbb699.png";